export interface ResourceIdApi {
  resourceId: string;
}

export let isResourceIdResponseDTO = (
  variable: unknown
): variable is ResourceIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "resourceId" in variable &&
    typeof variable.resourceId === "string"
  );
};
